import {EventEmitter} from 'events';
import Dispatcher from './Dispatcher';
import {
  DIVISIONS_CHOOSE,
  DIVISIONS_HOVER,
  DIVISIONS_SET_TARGET, GAME_PAUSE_TOGGLE,
  INITIALIZE
} from "./actionConstants";
import {
  combatWidthX, combatWidthY,
  DEBUG_DAMAGE_ENABLED,
  DEBUG_LOW_ALLIES_COUNT,
  DEBUG_MOVEMENT_ENABLED, myWidth, PERIOD_LENGTH,
  SIDES_ENEMY,
  SIDES_ME, step, TROOP_TYPE_INFANTRY,
} from "./constants";
import {
  playSound, SOUNDS_DEATH_ENEMY, SOUNDS_DEATH_MY,
  SOUNDS_DIVISION_SELECTED,
  SOUNDS_MELEE_1, SOUNDS_MELEE_2,
  SOUNDS_MOVEMENT_ORDER_1,
  SOUNDS_MOVEMENT_STEPS
} from "./SoundManager";
import {CAMPAIGNS} from "./Campaigns";


const CE = 'CHANGE_EVENT';


const cell = {}

const takeCell = (cellX, cellY, w, index) => {
  cell[cellX][cellY].troops[index] = {
    index,
    side: w.side,
    divisionId: w.divisionId
  }
  cell[cellX][cellY].isEmpty = false;
}

const removeWarriorFromCell = (cellX, cellY, index) => {
  delete cell[cellX][cellY].troops[index]
}

const getCellIndex = v => Math.floor(v)

const resetCells = () => {
  for (var i = 0; i < combatWidthX; i++) {
    cell[i] = {}

    for (var j = 0; j < combatWidthY; j++) {
      cell[i][j] = {
        isEmpty: true,
        isFighting: false,
        // isCrossable: true (map)

        troops: {}
      }
    }
  }

  warriors.forEach((w, index) => {
    var cellX = getCellIndex(w.x)
    var cellY = getCellIndex(w.y)

    if (isAlive(w)) {
      takeCell(cellX, cellY, w, index)
    }
  })
}



const shuffleArray = IDs => {
  var arr = [];
  while (IDs.length) {
    if (IDs.length === 1) {
      arr.push(IDs[0])
      IDs = []
    } else {
      var r = Math.floor(Math.random() * IDs.length)
      arr.push(IDs[r])
      IDs.splice(r, 1);
    }
  }

  return arr
}

const campaign = CAMPAIGNS.aragvelian300;

var chosenDivisionId = -1;
var hoveredDivisionId = -1;

var currentTime = 0;

var battleEnded = false;
var battleTimer = -1;

var testWarriorIndex = 0;
var stage = 0;

var knowsHowToMove = false;
var knowsHowToPause = false;
var knowsHowToSelectTroops = false;
var isPaused = true;

var divisions = {};
var warriors = [];
var engaged = {};

var kills = 0;

var empty = [];
var allied = [];
var enemies = [];
var movable = [];
var fighting = [];

var loaded = false

// ex state ends there
const diedDivisions = {}

class Warrior {
  constructor(divisionId, color, type, x, y) {
    this.color = color
    this.divisionId = divisionId
    this.type = type;
    this.x = x;
    this.y = y;
  }
}
const createWarriors = ({divisionId, side, count, width, startX=0, startY=0}) => {
  var warriors = [];

  for (var i = 0; i < count; i++) {
    const {x, y} = getCoordinates(count, i, width, startX, startY);
    // const w = new Warrior(divisionId, color, "infantry", x, y)
    const w = {
      divisionId,
      color: side,
      type: "infantry",
      x,
      y,
      side,
      targetX: x,
      targetY: y,
      health: 100
    }

    warriors.push(w)
  }

  return warriors
}
const getCoordinates = (count, i, width, startX, startY) => {
  // for (var i = 0; i < division.count; i++) {
  var x = i % width
  var y = Math.floor(i / width)

  return {x: x + startX, y: y + startY}
  // }
}

const getDelta = (d1, d2) => {
  return {
    x: d2.x - d1.x,
    y: d2.y - d1.y
  }
}
const getDistance = (d2, d1) => {
  const dX = d2.x - d1.x;
  const dY = d2.y - d1.y;

  return Math.sqrt(dX * dX + dY * dY)
}
const getWarriorDelta = w => {
  return {
    x: w.targetX - w.x,
    y: w.targetY - w.y
  }
}

var normalise = diff => {
  if (diff < -step)
    return -step

  if (diff > step)
    return step;

  return diff
}
const getNormalisedDelta = w => {
  const d = getWarriorDelta(w);

  return {
    x: normalise(d.x),
    y: normalise(d.y),
  }
}

const isAlive = w => w.health > 0;


const setDivisionTarget = (divisionId, targetX, targetY, renderOrNot, enemyDivisionId) => {
  // const ind = this.state.divisions.findIndex(d => d.divisionId === divisionId)

  const divisionCount = getDivisionCount(divisionId) // warriors.filter(w => w.divisionId === divisionId).length

  var myWarriorIndex = 0;
  warriors.forEach((w, index) => {
    if (w.divisionId === divisionId && isAlive(w)) {
      const target = getCoordinates(divisionCount, myWarriorIndex, myWidth, targetX, targetY)

      warriors[index].targetX = target.x;
      warriors[index].targetY = target.y;

      myWarriorIndex++
    }
  })

  return true;
}


const isMoving = w => w.x !== w.targetX || w.y !== w.targetY


const getDivision = divisionId => {
  return divisions[divisionId]
  // divisions.find(d => d.divisionId === divisionId)
}
const getDivisionWarriors = divisionId => warriors.filter(w => isAlive(w) && w.divisionId === divisionId)
const getDivisionCount = divisionId => {
  return getDivisionWarriors(divisionId).length
  // return warriors.filter(w => isAlive(w) && w.divisionId === divisionId).length
}





const appendEnemies = (newDivisions) => {
  console.log('append enemies', stage)

  divisions.push(...newDivisions);

  // TODO place IDs only to new divs
  divisions.forEach((t, index) => {
    divisions[index].setDivisionId(index);
  })

  newDivisions.forEach(d => {
    warriors.push(...createWarriors(d))
  })

  stage++
}

const getTroopsRemaining = (side) => {
  var divs = getSideDivisions(side);

  var warrs = 0;
  divs.forEach(d => {
    warrs += getDivisionCount(d.divisionId)
  })

  return warrs;
}

const getSideDivisions  = side => divisions.filter(d => d.side === side)
const getEnemyDivisions = () => getSideDivisions(SIDES_ENEMY)
const getMyDivisions    = () => getSideDivisions(SIDES_ME)


const getDivisionCenter = divisionId => {
  var divWarriors = getDivisionWarriors(divisionId);

  var centerX = 0
  var centerY = 0

  divWarriors.forEach(dW => {
    centerX += dW.x;
    centerY += dW.y;
  })

  var cnt = divWarriors.length;
  if (cnt)
    return {x: centerX / cnt, y: centerY / cnt}

  return {x: -10000, y: -10000, exists: false}
}

const setTargetsForAI = () => {
  // var divisions = this.state.divisions;
  var divisionCenters = {};

  divisions.forEach(d => {
    var divWarriors = getDivisionWarriors(d.divisionId);

    var centerX = 0
    var centerY = 0
    divWarriors.forEach(dW => {
      centerX += dW.x;
      centerY += dW.y;
    })

    var cnt = divWarriors.length;
    if (cnt)
      divisionCenters[d.divisionId] = {divisionId: d.divisionId, x: centerX / cnt, y: centerY / cnt, my: d.side === SIDES_ME}

    // var c = this.getDivisionCenter(d.divisionId)
    // if (c.exists)
    //   divisionCenters[d.divisionId] = Object.assign({}, c, {divisionId: d.divisionId, my: d.side === SIDES_ME})
  })

  var myDivisions = Object.values(divisionCenters).filter(dC => dC.my)
  var enemyDivisions = Object.values(divisionCenters).filter(dC => !dC.my)

  enemyDivisions.forEach(d => {
    var myNearestDivision = myDivisions
      .map(myD => Object.assign({}, myD, {distance: getDistance(myD, d)}))
      .sort((d1, d2) => d1.distance - d2.distance)[0]

    if (myNearestDivision) {
      setDivisionTarget(d.divisionId, myNearestDivision.x, myNearestDivision.y, false)
    }
  })
}

const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

const playBattleSounds = (play) => {
  playSound(SOUNDS_MELEE_1, play, 0.25)
  playSound(SOUNDS_MELEE_2, play, 0.25)
}

const playSoundIfDivisionDied = () => {
  divisions.forEach(d => {
    var rem = getDivisionCount(d.divisionId);

    if (rem === 0 && !diedDivisions[d.divisionId]) {
      playSound(d.side === SIDES_ME ? SOUNDS_DEATH_MY : SOUNDS_DEATH_ENEMY)
      diedDivisions[d.divisionId] = true
    }
  })
}

const addEnemiesIfCleanedTheWave = () => {
  var remaining = getTroopsRemaining(SIDES_ENEMY)
  if (remaining === 0)
    appendEnemies(campaign.enemyWaves[stage])
}
const endBattleIfIHaveNoTroops = () => {
  console.log('endBattleIfIHaveNoTroops')
  var myRemaining = getTroopsRemaining(SIDES_ME)
  if (myRemaining === 0) {
    // stopSounds()

    battleEnded = true
    isPaused = true
  }
}

const markAsFightingField = (x, y) => {
  cell[x][y].isFighting = true
}

const processBattle = () => {
  if (battleEnded || isPaused) {
    store.emitChange()
    return;
  }



  const iWantToAttack = []



  const getEnemiesOnField = (x, y, side, index) => {
    var enemies = []

    var cellX = getCellIndex(x)
    var cellY = getCellIndex(y)

    var range = 1;
    var i0 = clamp(cellX - range, 0, combatWidthX)
    var iMax = clamp(cellX + range, 0, combatWidthX)

    var j0 = clamp(cellY - range, 0, combatWidthY)
    var jMax = clamp(cellY + range, 0, combatWidthY)

    for (var i = i0; i <= iMax; i++) {
      for (var j = j0; j <= jMax; j++) {
        try {

        var field = cell[i][j];

        if (!field.isEmpty) {
          Object.values(field.troops).forEach(c => {
            var dude    = warriors[c.index]
            var isEnemy = dude.side !== side

            if (isEnemy && isAlive(dude)) {
              markAsFightingField(cellX, cellY)
              markAsFightingField(i, j)

              var dX = x - dude.x
              var dY = y - dude.y
              var distance = Math.sqrt(dX * dX + dY * dY)

              enemies.push({attacker: index, index: c.index, distance})
            }
          })
        }
        } catch (e) {

        }
      }
    }

    return enemies;
  }

  const attackNearest = (w, index, enemies) => {
    if (enemies.length) {
      var nearest = enemies.sort((e1, e2) => e1.distance - e2.distance)[0]
      var division = getDivision(w.divisionId);

      // save attacking intention
      iWantToAttack.push({
        attacker: index,
        target: nearest.index,
        damage: division.attack,
      })
    }
  }

  const searchEnemies = (w, index) => {
    if (isAlive(w))
      attackNearest(w, index, getEnemiesOnField(w.x, w.y, w.side, index))
  }

  const searchFighters = () => {
    warriors.forEach(searchEnemies)
  }


  const dealDamage = () => {
    var randomIndices = shuffleArray(iWantToAttack)

    randomIndices.forEach(iw => {
      var damage = iw.damage * PERIOD_LENGTH / 1000 / 2

      warriors[iw.target].health -= damage * (100 + Math.floor(Math.random() * 100)) / 100;
    })
  }


  const tryMoving = (index) => {
    const w = warriors[index]

    if (isAlive(w) && isMoving(w)) {
      var delta = getNormalisedDelta(w)

      const newX = w.x + delta.x;
      const newY = w.y + delta.y;

      const newCellX = getCellIndex(newX)
      const newCellY = getCellIndex(newY);

      const prevCellX = getCellIndex(w.x)
      const prevCellY = getCellIndex(w.y)



      const newCell = cell[newCellX][newCellY]

      var canMove = false;

      var isFighting = newCell.isFighting
      var isEmpty    = newCell.isEmpty

      canMove = !isFighting

      if (canMove) {
        warriors[index].x = newX
        warriors[index].y = newY

        if (chosenDivisionId === w.divisionId)
          playSound(SOUNDS_MOVEMENT_STEPS, true, 0.25)

        // false - just moves on map, true - will take new cell
        const willChangeCell = prevCellX !== newCellX || prevCellY !== newCellY
        if (willChangeCell) {
          removeWarriorFromCell(prevCellX, prevCellY, index)
          takeCell(newCellX, newCellY, w, index);

          getEnemiesOnField(prevCellX, prevCellY, w.side, index)
          getEnemiesOnField(newCellX, newCellY, w.side, index)
        }
      }
    }
  }

  const calculateMovements = () => {
    warriors.forEach((w, index) => {
      try {
        tryMoving(index);
      } catch (e) {

      }
    })
  }


  // calc map
  // calc damage
  // calc goals
  // calc movement

  resetCells()
  searchFighters()

  if (DEBUG_DAMAGE_ENABLED)
    dealDamage()

  setTargetsForAI()

  if (DEBUG_MOVEMENT_ENABLED)
    calculateMovements()



  // --------- AUXILIARIES -------------
  playBattleSounds(!!iWantToAttack.length)

  // Add more enemies
  addEnemiesIfCleanedTheWave()

  // play division dead sounds
  playSoundIfDivisionDied()
  endBattleIfIHaveNoTroops()

  currentTime += PERIOD_LENGTH / 1000

  store.emitChange()
}

battleTimer = setInterval(processBattle, PERIOD_LENGTH)


class Storage extends EventEmitter {
  addChangeListener(c) {
    this.addListener(CE, c);
  }

  emitChange() {
    this.emit(CE);
  }

  getWarriors() {
    return warriors;
  }
  getDivisions() {
    return divisions
  }
  isLoaded() {
    return loaded
  }
  getCurrentTime() {
    return currentTime
  }
  isBattleEnded() {
    return battleEnded;
  }
  getStage() {
    return stage
  }

  getFighting() {
    return fighting
  }

  getDivisionWarriors(divisionId) {
    return getDivisionWarriors(divisionId)
  }

  getHoveredDivisionId() {
    return hoveredDivisionId
  }
  getChosenDivisionId() {
    return chosenDivisionId
  }

  isPaused() {
    return isPaused;
  }

  isAlive(w) {
    return isAlive(w)
  }

  getTutorialStats() {
    return {
      knowsHowToMove,
      knowsHowToPause,
      knowsHowToSelectTroops,
    }
  }

  isMoving(w) {
    return isMoving(w)
  }
  getDivision(divisionId) {
    return divisions[divisionId]
  }
  getDivisionCenter(divisionId) {
    return getDivisionCenter(divisionId)
  }
  getMyDivisions() {
    return getMyDivisions()
  }
  getDivisionCount(divisionId) {
    return getDivisionCount(divisionId)
  }
}

const store = new Storage();

Dispatcher.register((p) => {
  switch (p.actionType) {
    case INITIALIZE:
      chosenDivisionId = -1;
      hoveredDivisionId = -1;

      currentTime = 0;

      battleEnded = false;
      battleTimer = -1;

      testWarriorIndex = 0;
      stage = 0;

      knowsHowToMove = false;
      knowsHowToPause = false;
      knowsHowToSelectTroops = false;

      isPaused = true;

      divisions = [];
      warriors = [];
      engaged = {};

      kills = 0;

      empty = [];
      allied = [];
      enemies = [];
      movable = [];
      fighting = [];

      loaded = true

      divisions = [...campaign.myWaves[0]]

      divisions.forEach((d, index) => {
        divisions[index].setDivisionId(index);
      })

      divisions.forEach(d => {
        warriors.push(...createWarriors(d))
      })

      store.emitChange()
      break

    case DIVISIONS_SET_TARGET:
      if (chosenDivisionId >= 0) {
        // playSound(Math.random() < 0.5 ? SOUNDS_MOVEMENT_ORDER_1 : SOUNDS_MOVEMENT_ORDER_2)
        playSound(SOUNDS_MOVEMENT_ORDER_1)

        setDivisionTarget(chosenDivisionId, Math.floor(p.x), Math.floor(p.y), true)

        knowsHowToMove = true;
      }

      store.emitChange()
      break

    case DIVISIONS_HOVER:
      hoveredDivisionId = p.divisionId

      store.emitChange()
      break;

    case DIVISIONS_CHOOSE:
      chosenDivisionId = p.divisionId
      knowsHowToSelectTroops = true;
      playSound(SOUNDS_DIVISION_SELECTED);

      store.emitChange()
      break;

    case GAME_PAUSE_TOGGLE:
      console.log("togglePause")
      isPaused = !isPaused;
      knowsHowToPause = true

      store.emitChange()
      break;

    default:
      console.warn(`TYPE IS FUCKED. Got unexpected type ${p.type}`);
      break;
  }
});

export default store;